import { LocaleType } from 'aws-sdk/clients/workdocs'
import { LOCALE_KO } from '../../../../modules/i18n/config'
import { IMG_POPUP_GUIDE_CLASSROOM_EN, IMG_POPUP_GUIDE_CLASSROOM_KO } from '../../../../modules/images'

const PopupSettingModalBody = ({ locale }: { locale: LocaleType }) => {
  return (
    <div>
      <img
        src={locale === LOCALE_KO ? IMG_POPUP_GUIDE_CLASSROOM_KO : IMG_POPUP_GUIDE_CLASSROOM_EN}
        alt="popup setting guide"
      />
    </div>
  )
}

export default PopupSettingModalBody
